var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKycIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 115,
    viewBox: "0 0 114 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: 0,
    y: 0.5,
    width: 114,
    height: 114
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(4px)",
      clipPath: "url(#bgblur_0_2810_111279_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2810_111279)",
    "data-figma-bg-blur-radius": 8
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 17.5,
    width: 64,
    height: 64,
    rx: 12.8,
    fill: "#610ECD",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 17.5,
    width: 64,
    height: 64,
    rx: 12.8,
    fill: "url(#paint0_linear_2810_111279)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 17,
    width: 65,
    height: 65,
    rx: 13.3,
    stroke: "#D9CDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3337 54C49.2939 54.0002 52.4998 57.2251 52.4998 61.167C52.4997 62.0067 52.3574 62.8192 52.0662 63.5654C51.6327 64.8169 50.8468 65.9011 49.8552 66.7334L49.8455 66.7412C48.6135 67.7232 47.0549 68.3329 45.3337 68.333C41.3919 68.333 38.1669 65.1271 38.1667 61.167C38.1667 59.4651 38.7583 57.904 39.7615 56.668C40.0022 56.3552 40.2751 56.0852 40.5544 55.8408C41.8247 54.6981 43.5071 54 45.3337 54ZM42.1501 62.1504C41.9696 62.1504 41.8337 62.2829 41.8337 62.4668V62.6338C41.834 63.4434 42.479 64.0828 43.2664 64.083H47.4666L47.0535 64.8262C46.9933 64.9347 47.0065 65.0584 47.0642 65.1377L47.0925 65.1689L47.1072 65.1826L47.1218 65.1992C47.1497 65.23 47.2123 65.2666 47.3337 65.2666C47.4041 65.2665 47.4809 65.2347 47.5281 65.1826L47.5388 65.1709L47.5486 65.1611L48.7488 63.9775C48.7649 63.9607 48.7893 63.9252 48.8201 63.8779C48.8364 63.8046 48.835 63.7291 48.8162 63.6562C48.7876 63.6055 48.7611 63.568 48.7468 63.5537L47.5369 62.3438C47.4392 62.2409 47.2467 62.2267 47.1199 62.3535C47.0242 62.4493 47.0007 62.5902 47.0759 62.7334L47.4617 63.4668H43.283C42.7909 63.4665 42.4668 63.0587 42.4666 62.6338V62.4668C42.4666 62.283 42.3307 62.1504 42.1501 62.1504ZM43.5281 57.1514C43.4319 57.0446 43.2546 57.0297 43.1296 57.1611L43.1179 57.1729L41.9177 58.3564L41.8992 58.374L41.8953 58.376L41.8601 58.4404C41.8574 58.4454 41.8538 58.4508 41.8503 58.457C41.8304 58.5344 41.8296 58.615 41.8494 58.6924C41.8784 58.7442 41.9064 58.7826 41.9207 58.7969L43.1199 59.9961C43.1718 60.048 43.2601 60.083 43.3337 60.083C43.4405 60.0829 43.5114 60.048 43.5632 59.9961C43.659 59.9002 43.6826 59.7596 43.6072 59.6162L43.2214 58.8838H47.3835C47.876 58.8839 48.2 59.2916 48.2 59.7168V59.8838C48.2002 60.0673 48.3361 60.2 48.5164 60.2002C48.6619 60.2002 48.7774 60.1132 48.8171 59.9834V59.7168C48.8171 58.9068 48.1712 58.2667 47.3835 58.2666H43.1833L43.5964 57.5234C43.6651 57.3996 43.6379 57.2565 43.5583 57.1816L43.5427 57.167L43.5281 57.1514Z",
    fill: "#EBE4FF",
    stroke: "#FBFAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7501 36.0834V42.4167H59.2501V36.0834C59.2501 35.6334 58.8501 35.4167 58.5834 35.4167C58.5001 35.4167 58.4167 35.4334 58.3334 35.4667L45.1167 40.4501C44.2334 40.7834 43.6667 41.6167 43.6667 42.5667V43.6834C42.1501 44.8167 41.1667 46.6334 41.1667 48.6834V42.5667C41.1667 40.5834 42.3834 38.8167 44.2334 38.1167L57.4667 33.1167C57.8334 32.9834 58.2167 32.9167 58.5834 32.9167C60.2501 32.9167 61.7501 34.2667 61.7501 36.0834Z",
    fill: "#FBFAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8333 53.6667V55.3334C72.8333 55.7834 72.4833 56.15 72.0166 56.1667H69.5833C68.7 56.1667 67.9 55.5167 67.8333 54.65C67.7833 54.1334 67.9833 53.65 68.3166 53.3167C68.6166 53 69.0333 52.8334 69.4833 52.8334H72C72.4833 52.85 72.8333 53.2167 72.8333 53.6667Z",
    fill: "#FBFAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4333 43.2496H66.5671C69.5567 43.2498 71.9997 45.6936 71.9998 48.6832V49.4166C71.9998 49.8731 71.6232 50.2496 71.1667 50.2496H69.4666C68.31 50.2497 67.2441 50.7061 66.4695 51.5016C65.4365 52.5069 64.9518 54.04 65.3611 55.5953L65.3621 55.5992C65.8938 57.5771 67.8103 58.7496 69.7166 58.7496H71.1667C71.6232 58.7496 71.9998 59.1272 71.9998 59.5836V59.9C71.9997 62.8896 69.5567 65.3334 66.5671 65.3336H54.4832C54.4783 65.3336 54.4787 65.3329 54.4783 65.3326C54.475 65.3306 54.4652 65.3227 54.4548 65.3053C54.4311 65.2656 54.4302 65.2215 54.4451 65.1881L54.449 65.1783C54.9838 63.9303 55.3337 62.5015 55.3337 61.1666C55.3337 55.6565 50.8438 51.1668 45.3337 51.1666C44.2572 51.1666 43.1835 51.3482 42.1667 51.693C42.1146 51.7094 42.0601 51.6999 42.0232 51.6764C42.0085 51.667 42.0023 51.6592 42.0007 51.6569C42.0007 51.6569 41.9998 51.6548 41.9998 51.65V48.6832C41.9998 46.9058 42.8518 45.3331 44.1658 44.3512L44.1716 44.3463C45.0803 43.654 46.2039 43.2496 47.4333 43.2496ZM51.9998 47.4166C50.8564 47.4168 49.9169 48.3563 49.9167 49.4996C49.9167 50.6431 50.8563 51.5834 51.9998 51.5836H60.3337C61.4772 51.5834 62.4167 50.6431 62.4167 49.4996C62.4166 48.3563 61.4771 47.4168 60.3337 47.4166H51.9998Z",
    fill: "#EBE4FF",
    stroke: "#FBFAFF",
    strokeWidth: 1.66667
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2810_111279",
    x: 0,
    y: 0.5,
    width: 114,
    height: 114,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.37398 0 0 0 0 0.193943 0 0 0 0 0.607543 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2810_111279"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2810_111279",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_2810_111279_clip_path",
    transform: "translate(0 -0.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 17.5,
    width: 64,
    height: 64,
    rx: 12.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2810_111279",
    x1: 25,
    y1: 17.5,
    x2: 89,
    y2: 81.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#DB6704",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#DB6704",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825,
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKycIcon);
export default __webpack_public_path__ + "static/media/KYCIcon.a5c820ddcc53b134bb0f357f255dd8d7.svg";
export { ForwardRef as ReactComponent };